import React, { useEffect } from "react";
import { getFavicon } from "./apis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeContainer from "./containers/HomeContainer";
import PrivacyPolicyContainer from "./containers/PrivacyPolicyContainer";
import TermsContainer from "./containers/TermsContainer";
import WithdrawalOfMembershipContainer from "./containers/WithdrawalOfMembershipContainer";
import ProductContainer from "./containers/ProductContainer";

function App() {
  useEffect(() => {
    const fetchAndSetFavicon = async () => {
      try {
        const res = await getFavicon();
        const faviconUrl = res.data;
        if (faviconUrl) {
          let link = document.querySelector("link[rel*='icon']");
          if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
          }
          link.href = faviconUrl;
        }
      } catch (error) {
        console.error("Error fetching favicon:", error);
      }
    };

    fetchAndSetFavicon();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeContainer />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyContainer />} />
        <Route path="/terms-of-service" element={<TermsContainer />} />
        <Route
          path="/withdrawal-of-membership"
          element={<WithdrawalOfMembershipContainer />}
        />
        <Route path="/products/:id" element={<ProductContainer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
